export default [
    {
        key: "product_code",
        label: app.$i18n.t("Product code"),
        visible: true
    },
    {
        key: "product_description",
        label: app.$i18n.t("Product description"),
        visible: true
        
    },
    {
        key: "unit_code",
        label: app.$i18n.t("Unit code"),
        visible: true
    },
    {
        key: "quantity",
        label: app.$i18n.t("Quantity"),
        visible: true
    },
    {
        key: "volume",
        label: app.$i18n.t("Volume"),
        visible: true
    },
    {
        key: "weight",
        label: app.$i18n.t("Weight"),
        visible: true
    },
    {
        key: "actions",
        label: app.$i18n.t("Actions"),
        visible: true
    }
];